import { net_filemanage } from "@/api/http";
export const API_STFMFM02C31_Initialize = (...params) =>
net_filemanage.post("/api/STFMFM02C31/DisplayFunctionAuthoritySetting", ...params);

export const API_STFMFM02C31_UpdateFunctionAuthority = (...params) =>
net_filemanage.post("/api/STFMFM02C31/UpdateFunctionAuthority", ...params);